import { GamePriceDataResponse } from '@/features/games/shared/types/game-data';
import { GamePriceMap } from '@/features/games/shared/types/game-store.types';
import { cloudPriceToPriceIncludingWildMembershipPrices } from '@/features/games/shared/helpers/cloud-price-to-price-including-wild-membership-prices';
import { cloudPriceEntriesToCloudPrices } from '@/features/games/internal/helpers/cloud-price-entries-to-cloud-prices';
import { CloudPriceEntries, PriceIncludingWildMembership } from '@/shared/types/prices';

export function mapGamePrices(
  rawPrices: GamePriceDataResponse,
  isMember: boolean,
  currencyCode: string = 'USD',
): Partial<GamePriceMap> {
  const currencyFilteredPrices = cloudPriceEntriesToCloudPrices(rawPrices.prices, currencyCode);

  const result: Partial<GamePriceMap> = {
    buy: null,
    rent: null,
    tokens: null,
  };
  result.buy = cloudPriceToPriceIncludingWildMembershipPrices(
    currencyFilteredPrices,
    isMember,
    true,
  );
  result.rent = cloudPriceToPriceIncludingWildMembershipPrices(
    currencyFilteredPrices,
    isMember,
    false,
  );
  const tokens = currencyFilteredPrices.find((p) => p.type === 'tokens');
  const tokensValue = tokens?.value ?? 0;
  result.tokens =
    isMember && tokensValue > 0
      ? [
          {
            type: 'tokens',
            value: tokensValue,
            currencyCode: 'USD',
          },
        ]
      : null;
  return result;
}

export function mapPromotionPrices(
  promotionPrices: CloudPriceEntries,
  isMember: boolean,
  currencyCode: string = 'USD',
): PriceIncludingWildMembership[] | undefined {
  if (!promotionPrices) return undefined;
  const currencyFilteredPrices = cloudPriceEntriesToCloudPrices(promotionPrices, currencyCode);
  return cloudPriceToPriceIncludingWildMembershipPrices(currencyFilteredPrices, isMember, true);
}
